import { AfterViewChecked, Component, EventEmitter, HostListener, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { iframeResizer } from 'iframe-resizer';
import { QuoteModel } from 'src/app/models/quote.model';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-magnum-questions',
  templateUrl: './magnum-questions.component.html',
  styleUrls: ['./magnum-questions.component.scss'],
})
export class MagnumQuestionsComponent implements OnInit, OnDestroy, AfterViewChecked {

  @Input() quote: QuoteModel;
  @Output() complete = new EventEmitter();

  magnumUrl: SafeResourceUrl = null;
  magnumHost: string;
  loading: boolean;
  timedOut = false;
  timeoutTimer: number;
  iframes: any;

  @HostListener('window:message', ['$event']) onPostMessage($event: any) {
    if ($event.origin === this.magnumHost) {
      if ($event.data.status === 'complete')
        this.complete.emit($event.data);
      else if ($event.data.status === 'timeout')
        this.timedOut = true;
    }
  }

  constructor(
    private api: ApiService,
    private sanitizer: DomSanitizer,
    private zone: NgZone
  ) { }

  ngAfterViewChecked(): void {
    if (!this.iframes && this.magnumUrl)
      this.iframes = iframeResizer({
        // log: true,
        checkOrigin: false,
        resizedCallback: (data) => {
          if (data.height > 150)
            this.loading = false;
        }
      }, '#magnumIframe');
  }

  ngOnDestroy(): void {
    if (this.timeoutTimer)
      clearTimeout(this.timeoutTimer);
  }

  async ngOnInit() {
    await this.loadQuestions();
  }

  async retry() {
    this.timedOut = false;
    await this.loadQuestions();
  }

  async loadQuestions() {
    this.loading = true;
    try {
      let rsp = await this.api.getMagnumUrl(this.quote.key);//`${environment.baseUrl}/Home/MagnumTest`;
      const url = rsp.applicationLink;
      this.magnumHost = /https?:\/\/[^/]+/.exec(url)[0];
      this.magnumUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      setTimeout(() => this.zone.run(() => {
        this.loading = false;
        console.log('setting loading to false due to timeout');
      }), 10 * 1000);
    }
    catch (e) {
      this.loading = false;
      console.log('error loading Magnum: %o', e);
    }

  }
}
